import Constants from '@/Constants';
import { LanguageType } from '@/models/LanguageType';
import { getFormattedDate } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import LearningMapModal from '../Modal';
const LearningMapEditingSection: React.FC = () => {
    const { strings, currentLearningMap } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        currentLearningMap: state.learningMap.data.currentLearningMap,
    }));

    const [showLearningMap, setShowLearningMap] = useState<boolean>(false);

    const getUpdateTime = (date: Date): string => getFormattedDate(date, 'dd/MM/yyyy HH:mm', strings._LANGUAGE as LanguageType);

    const handleModalClose = () => {
        setShowLearningMap(false);
    };

    return (
        <div className="edit-section-container">
            <div className="info-container">
                <div className="title-container">
                    <span className="title">{strings.PROFILE_MENU.LEARNING_MAP}</span>
                    <button className="edit-link" onClick={() => setShowLearningMap(!showLearningMap)}>
                        <i className="material-icons">{Constants.icons.EDIT}</i>
                    </button>
                    <LearningMapModal handleModalClose={handleModalClose} showLearningMap={showLearningMap} />
                </div>
                {currentLearningMap.updatedOn && (
                    <span className="description">{strings.LAST_UPDATE.replace('%s', getUpdateTime(currentLearningMap.updatedOn))}</span>
                )}
            </div>
        </div>
    );
};
export default LearningMapEditingSection;
